import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import GriEmpowerment from "../../assets/images/GriEmpowerment.png";

const CountrySpecificCompliance = () => {
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
      </Box>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="dashboardImg4_2"
            title={"Country Specific ESG Compliance"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              className="mb-4"
              variant="h6"
              style={{
                fontWeight: 700,
                color: "#02462E",
                mb: 3,
                fontSize: "40px",
                fontFamily: "DM Sans",
                lineHeight: "38px",
                letterSpacing: "-2%",
              }}
            >
              The global standards for Environmental <br />
              sustainability.{" "}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                gap: { xs: 4, md: 8 },
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <CustomButton
                  title="Canada"
                  route="/industry-country-specific-standard/country-specific-compliance/canada"
                />
                <CustomButton
                  title="United Arab Emirates (UAE)"
                  route="/industry-country-specific-standard/country-specific-compliance/uae"
                />
                <CustomButton
                  title="France"
                  route="/industry-country-specific-standard/country-specific-compliance/france"
                />
                <CustomButton
                  title="Germany"
                  route="/industry-country-specific-standard/country-specific-compliance/germany"
                />
                <CustomButton
                  title="Italy"
                  route="/industry-country-specific-standard/country-specific-compliance/italy"
                />
                <CustomButton
                  title="Netherlands"
                  route="/industry-country-specific-standard/country-specific-compliance/netherlands"
                />
                <CustomButton
                  title="Spain"
                  route="/industry-country-specific-standard/country-specific-compliance/spain"
                />
                <CustomButton
                  title="Pakistan"
                  route="/industry-country-specific-standard/country-specific-compliance/pakistan"
                />
                <CustomButton
                  title="Bangladesh"
                  route="/industry-country-specific-standard/country-specific-compliance/bangladesh"
                />
                <CustomButton
                  title="Nigeria"
                  route="/industry-country-specific-standard/country-specific-compliance/nigeria"
                />
                <CustomButton
                  title="Singapore"
                  route="/industry-country-specific-standard/country-specific-compliance/singapore"
                />
                <CustomButton
                  title="Malaysia"
                  route="/industry-country-specific-standard/country-specific-compliance/malaysia"
                />
                <CustomButton
                  title="Indonesia"
                  route="/industry-country-specific-standard/country-specific-compliance/indonesia"
                />
                <CustomButton
                  title="Vietnam"
                  route="/industry-country-specific-standard/country-specific-compliance/vietnam"
                />
                <CustomButton
                  title="Thailand"
                  route="/industry-country-specific-standard/country-specific-compliance/thailand"
                />
                <CustomButton
                  title="Philippines"
                  route="/industry-country-specific-standard/country-specific-compliance/philippines"
                />
                <CustomButton
                  title="AI Auto-select Country Specific ESG Compliance"
                  route="/industry-country-specific-standard/country-specific-compliance/auto-select-ai"
                />
              </Box>

              {/* <Box
                                component="img"
                                src={GriEmpowerment}
                                alt="Gri Empowerment"
                                sx={{
                                    width: '192px',
                                    height: '202px',
                                    ml: { xs: 0, md: 4 },
                                    mt: { xs: 4, md: 0 },
                                    flexShrink: 0,
                                }}
                            /> */}
            </Box>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default CountrySpecificCompliance;
